export enum AccountType {
    PERSONAL = 'AKMA',
    CASH_REGISTER = 'AKKASSA',
}
